import { B2bVystupyTable } from './B2bVystupyTable';
import './stranky.css';

export function KlientVystupy({ partnerId }: { partnerId: number }): JSX.Element {
  return (
    <div className="st-promo-tab">
      <B2bVystupyTable partnerId={partnerId} showKind showClient={false} />
    </div>
  );
}
